import React from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon } from 'lucide-react';
export function WhyLancer() {
  const specialties = ["Problems other shops couldn't identify", 'Recurring check engine lights', 'Electrical or sensor issues', 'Multiple warning lights appearing at once', 'Intermittent drivability problems', "Repairs that didn't fix the original issue"];
  return <section className="py-20 px-4 bg-white" data-id="element-238">
      <div className="max-w-5xl mx-auto" data-id="element-239">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-240">
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-6 pl-[0px] pr-[0px]" data-id="element-241">
            We specialize in solving the problems others can't find.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-242">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-243">
            <p className="font-bold text-brand-dark text-xl mb-6" data-id="element-244">
              We frequently help with:
            </p>
            <ul className="space-y-4" data-id="element-245">
              {specialties.map((item, index) => <li key={index} className="flex items-start gap-4 bg-brand-light p-4 rounded-xl border border-gray-100" data-id="element-246">
                  <WrenchIcon className="w-6 h-6 text-brand-accent flex-shrink-0" data-id="element-247" />
                  <span className="text-lg text-gray-800 font-medium" data-id="element-248">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-700 leading-relaxed space-y-6" data-id="element-249">
            <p data-id="element-250">Many drivers have a shop they've trusted for years.</p>
            <p data-id="element-251">
              When that shop says a problem is beyond what they can handle, it
              can feel like the only option is the dealership.
            </p>
            <p className="font-bold text-brand-dark text-2xl" data-id="element-252">It isn't.</p>
            <p data-id="element-253">
              Lancer is an independent shop with the diagnostic technology to
              handle problems many smaller shops aren't equipped for — without
              losing the personal service you're used to.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}